import React from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, Icon, Divider, Button, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import Select from 'react-select';
import { getUsersProjects, getAssignedTasks, getWorkers, prepareFilters, getAllInvolvedUsers } from '../../firebase/db/team';
import _ from 'lodash';
import { Base64 } from 'js-base64';
import OverlayLevel1 from '../Overlay/OverlayLevel1';
import TaskDashboard from '../Tasks/TasksDashboard';
import LoadingProgress from '../common/LoadingProgress';
import { MAIN_COLOR } from '../../firebase-config';

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#f2f2f2',
        color: theme.palette.common.black,
        height: '45px',
        fontWeight: '400',
        fontSize: 17
    },
    body: {
        fontSize: 14,
    },
    root: {
        padding: '5px',
        textAlign: 'left',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        verticalAlign: 'inherit'
    }
}))(TableCell);
const styles = theme => ({
    filter: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
    },
    container: {
        margin: '3% 10% 0'
    },
    docContainer: {
        display: 'flex',
        flexFlow: 'row wrap'
    },
    select: {
        minWidth: '200px',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: 0,
        fontFamily: '-apple-system,system-ui,BlinkMacSystemFont,' + "'Roboto', sans-serif",
    },
    filter: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
    },
    textName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        paddingTop: '50px',
        fontSize: 14,
        width: 105
    },
    actions: {
        display: 'flex',
        flexDirection: 'row-reverse'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around'
    },
    row: {
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'row',
    },
    rowButton: {
        display: 'flex',
        flexDirection: 'row',
        padding: '10px',
        marginTop: 10,
        textTransform: 'none'
    },
    rowButton1: {
        display: 'flex',
        flexDirection: 'row',
        padding: '10px',
        marginTop: 10,
        textTransform: 'none',
        backgroundColor: MAIN_COLOR,
        color: 'white'
    },
    text: {
        position: 'relative',
        width: '25%',
        textAlign: 'right'
    },
    text1: {
        position: 'relative',
        width: '25%',
        textAlign: 'left'
    },
    fontSize: {
        fontSize: 30
    }
});
class Team extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            members: {},
            projects: [],
            cycles: {},
            tasks: {},
            workersTasks: {},
            tasksForFilter: {},
            user: {},
            open: false,
            isOverlayOpen: false,
            loading: true,
            areTagsOpen: false
        };
    }

    componentDidMount() {
        const { props: { auth }, } = this;
        getAllInvolvedUsers(auth.email)
            .then((members) => {
                let uniqueUserRoles = _.uniqWith(members, _.isEqual);
                this.setState({ members: uniqueUserRoles })
            });
        getUsersProjects(auth.email)
            .then(projects => {
                let uniqueProjects = _.uniqWith(projects, _.isEqual);
                getAssignedTasks(uniqueProjects)
                    .then(tasks => {
                        let workersTasks = getWorkers(tasks)
                        setTimeout(() => {
                            this.setState({ tasks, workersTasks: workersTasks, tasksForFilter: workersTasks }, () => {
                                prepareFilters(this.state.tasks)
                                    .then(filters => {
                                        const [projects] = filters;
                                        this.setState({ projects, loading: false });
                                    });

                            });
                        }, 2000);
                    });
            })
    }

    handleOpen = (worker, project) => {
        const { history, auth } = this.props;
        let assignedTo = worker;
        let projectId = project;

        console.log(auth.email);
        console.log(Base64.decode(assignedTo));
        console.log(projectId);

        this.setState({ isOverlayOpen: true, assignedTo, projectId });
        //history.push('tasks', { assignedTo, projectId })
    };

    handleChange = name => selected => {
        this.setState({ [name]: selected && selected.value }, () => {
            const { projectId, tasksForFilter } = this.state;
            let filteredTeam
            if (projectId) {
                filteredTeam = Object.keys(tasksForFilter)
                    .filter(worker => {
                        const member = tasksForFilter[worker];
                        if (projectId) {
                            return member[projectId];
                        }
                    })
                    .reduce((result, worker) => {
                        if (projectId) {
                            result[worker] = Object.assign({}, { [projectId]: tasksForFilter[worker][projectId] });
                            return result;
                        }
                    }, {});
            } else {
                filteredTeam = tasksForFilter;
            }
            this.setState({ workersTasks: filteredTeam })
        });
    };

    isDisabled(worker, project) {
        const { members } = this.state;
        const { auth } = this.props;
        return members.some((member) => {
            if (Object.values(member)[0][0] === 'manager' || Object.values(member)[0][0] === 'co-manager' && Object.keys(member)[0] === project) {
                return false;
            }
            if (Object.values(member)[0][0] === 'worker' && Object.keys(member)[0] === project && worker === window.btoa(auth.email)) {
                return false;
            }
            if (Object.values(member)[0][0] === 'worker' && Object.keys(member)[0] === project && worker !== window.btoa(auth.email)) {
                return true;
            }
        })
    }

    handleTaskOverlayClose = () => {
        this.setState({ isOverlayOpen: false, projectId: null, assignedTo: null, areTagsOpen: false });
    };

    hanldeToggleTags = (areTagsOpen) => {
        this.setState({ areTagsOpen });
    };

    render() {
        const { classes, auth } = this.props;
        const { workersTasks, projects, isOverlayOpen, assignedTo, projectId, loading, areTagsOpen } = this.state;
        let renderMembers = Object.keys(workersTasks).map((worker) => {
            if (!worker) return null;
            return (
                <TableRow>
                    <CustomTableCell>
                        {window.atob(worker) == auth.email ? window.atob(worker) + ' (ME)' : window.atob(worker)}
                    </CustomTableCell>
                    <CustomTableCell>  {Object.keys(workersTasks[worker]).map((project) => {
                        return <div className={classes.rowButton}>{Object.keys(workersTasks[worker][project])}<br></br></div>
                    })}</CustomTableCell>
                    <CustomTableCell>{Object.keys(workersTasks[worker]).map((project) => {
                        return <Button color="primary" variant="fab" mini disabled={this.isDisabled(worker, project)} className={classes.rowButton1} onClick={() => this.handleOpen(worker, project)}>
                            <div>{Object.values(workersTasks[worker][project])}<br></br></div>
                        </Button>
                    })}</CustomTableCell>
                </TableRow>
            )
        })

        if (loading) {
            return <LoadingProgress />
        }

        return (
            <div className={classes.container} >
                <div className={classes.filter}>
                    <Select
                        isClearable
                        isMulti={false}
                        onChange={this.handleChange('projectId')}
                        closeMenuOnSelect={false}
                        className={classes.select}
                        placeholder='Projekt'
                        options={projects}
                    />
                </div>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <CustomTableCell >BEARBEITER</CustomTableCell>
                            <CustomTableCell >PROJEKT</CustomTableCell>
                            <CustomTableCell >OFFENE TASKS</CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderMembers}
                    </TableBody>
                </Table>
                {isOverlayOpen && (
                    <React.Fragment>
                        <OverlayLevel1 open={isOverlayOpen} onClose={this.handleTaskOverlayClose} onClickOutsideOverlay={this.handleTaskOverlayClose} disableOnClickOutside={areTagsOpen}>
                            <TaskDashboard location={{ state: { assignedTo, projectId } }} overlayLevel={1} onTagsOpen={this.hanldeToggleTags} />
                        </OverlayLevel1>
                    </React.Fragment>
                )}
            </div>
        );
    }
}


export default withStyles(styles)(connect(state => ({
    auth: state.firebase.auth,
}))(Team));


// WEBPACK FOOTER //
// ./src/components/Team/Team.js